<script type="application/javascript">
import axios from 'axios';
import { VueReCaptcha } from 'vue-recaptcha-v3';
Vue.use(VueReCaptcha, { siteKey: '6Lf07pciAAAAAM-Ksg7rjTfoUee0fRAC-Au99uHN' });
export default {
    props: ['stripeKey', 'offers', 'deal', 'type', 'section', 'showBasic', 'plansType'],
    data() {
        return {
            name: '',
            email: '',
            couponCode: '',
            token: '',
            reCaptchaToken: '',
            userCoupon: null,
            price: '',
            errorMessage: '',
            busy: false,
            bfCoupon: '',
            professionalService: false,
            style: {
                base: {
                    iconColor: '#62647B',
                    color: '#1f2243',
                    fontSize: '16px',
                    fontSmoothing: 'antialiased',
                    height: '34px',
                    fontFamily: 'sans-serif',
                    '::placeholder': {
                        color: '#ADAEBA',
                    },

                },
                invalid: {
                    iconColor: '#62647B',
                    color: '#1f2243',
                },
            },
            stripe: Stripe(this.stripeKey),
            card: null,
            clientSecret: null,
            thankYou: false,
            redirectUrl: null,
        };
    },
    computed: {
        eventName() {
            if(this.plansType === 'monthly'){
                return 'MRR Purchased';
            }
            else if(this.plansType === 'yearly'){
                return 'Yearly Purchased';
            } else {
                return 'LTD Purchased';
            }
        },
    },
    async mounted() {
        if(this.deal && this.deal[this.plansType]) {
            this.price = parseInt(this.deal[this.plansType]);
        } else {
            this.price = parseInt(this.deal.price);
        }
        const elements = this.stripe.elements();
        const card = elements.create('card', {hidePostalCode: true, style: this.style});
        card.mount(this.$refs.cardElement);

        // Handle real-time validation errors from the card Element.
        card.addEventListener('change', event => {
            const displayError = document.getElementById('card-errors');
            if (event.error) {
                displayError.textContent = event.error.message;
            } else {
                displayError.textContent = '';
            }
        });
        this.card = card;

        await this.$recaptchaLoaded();
        // Execute reCAPTCHA with action "login".
        this.setCaptchaToken();
        setInterval(this.setCaptchaToken() , 2 * 60 * 1000);
    },
    watch: {
        professionalService() {
            if(this.professionalService) {
                this.price = parseInt(this.price + 199);
            } else {
                this.price = parseInt(this.deal[this.plansType]);
            }
        },
        plansType() {
            this.price = parseInt(this.deal[this.plansType]);
            if(this.professionalService) {
                this.price = parseInt(this.price + 199);
            }
        }
    },
    methods: {
        async setCaptchaToken() {
            this.reCaptchaToken = await this.$recaptcha('login');
        },
        submitForm() {
            if (this.busy) {
                return;
            }
            this.busy = true;

            this.stripe.createToken(this.card)
                .then(result => {
                    if (result.error) {
                        // Inform the user if there was an error.
                        const errorElement = document.getElementById('card-errors');
                        errorElement.textContent = result.error.message;
                        this.busy = false;
                    } else {
                        // Send the token to your server.
                        this.token = result.token.id;
                        // Submit the form
                        this.submit();
                    }
                });
        },
        success(res) {
            if(this.professionalService) {
                window.Intercom('boot', {
                    app_id: 'ujmidnoy',
                    user_id: this.email ,
                    professionalService: true,
                });
            }
            /* globals dataLayer */
            dataLayer.push({
                event: this.eventName,
                ltd_price: this.price,
                ltd_section: this.section,
                // GA4
                // name: 'purchase',
                planType: this.plansType,
                plan: this.deal.id,
                price: this.price,
                section: this.section,
            });

            this.thankYou = true;
            this.redirectUrl = res.data.redirect_url

            tap(res.data.tap.type, null, res.data.tap.amount, {
                program_group: 'ltd',
                customer_id: res.data.tap.customer_id
            });
        },
        confirmPayment() {
            return this.stripe.confirmCardPayment(this.clientSecret.secret, {
                payment_method: {
                    card: this.card
                }
            })
            .then(res => {
                if (res.error) {
                    const errorElement = document.getElementById('card-errors');
                    errorElement.textContent = res.error.message;
                    this.busy = false;
                } else {
                    this.success(this.clientSecret.res);
                }
            });
        },
        submit() {
            if(this.clientSecret) {
                this.confirmPayment();
                return;
            }
            axios.post('/purchase', {
                name: this.name,
                email: this.email,
                deal: this.deal.id,
                token: this.token,
                coupon: this.couponCode,
                type: this.plansType,
                professionalService: this.professionalService,
                reCaptchaToken: this.reCaptchaToken
            }).then((res) => {
                if (res.data.action_required.is_required) {
                    this.clientSecret = {
                        secret: res.data.action_required.client_secret,
                        res: res
                    };

                    return this.confirmPayment();
                }

                return this.success(res);

            }).catch((err) => {
                const errorElement = document.getElementById('card-errors');
                errorElement.textContent = err.response.data.message;

                this.busy = false;
            });
        }
    }
};

</script>


// WEBPACK FOOTER //
// resources/js/frontend/components/StripeCheckout.vue